const RANDOM_BYTES_LENGTH = 4;
const RANDOM_RADIX = 36;
const RANDOM_SUBSTRING_START = 2;
const RANDOM_SUBSTRING_END = 5;

export const getRandomValue = (): string => {
  try {
    // pretty decent browser support for crypto, but just in case it fails
    // we can fallback to a generic version using Math.random that will produce
    // a "random enough" value
    return window.crypto
      .getRandomValues(new Uint8Array(RANDOM_BYTES_LENGTH))
      .join('');
  } catch {
    return Math.random()
      .toString(RANDOM_RADIX)
      .substring(RANDOM_SUBSTRING_START, RANDOM_SUBSTRING_END);
  }
};
